var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1280 720" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0",
        y: "0",
        viewBox: "0 0 1280 720",
        "xml:space": "preserve",
      },
    },
    [
      _c("defs", [
        _c("path", {
          attrs: { id: "SVGID_1_", d: "M1339.5 1046.5h396v396h-396z" },
        }),
      ]),
      _c("clipPath", { attrs: { id: "SVGID_2_" } }, [
        _c("use", {
          staticStyle: { overflow: "visible" },
          attrs: { "xlink:href": "#SVGID_1_" },
        }),
      ]),
      _c(
        "g",
        {
          staticStyle: { "clip-path": "url(#SVGID_2_)" },
          attrs: { transform: "matrix(1.99 0 0 1.99 448 350)" },
        },
        [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_3_", d: "M-148-148h396v396h-396z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_4_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_3_" },
            }),
          ]),
          _c("circle", {
            staticClass: "st2",
            staticStyle: { "clip-path": "url(#SVGID_4_)" },
            attrs: { cx: "50", cy: "50", r: "50" },
          }),
        ]
      ),
      _c("defs", [
        _c("path", {
          attrs: { id: "SVGID_5_", d: "M-555.8 617.3H15.4v416h-571.2z" },
        }),
      ]),
      _c("clipPath", { attrs: { id: "SVGID_6_" } }, [
        _c("use", {
          staticStyle: { overflow: "visible" },
          attrs: { "xlink:href": "#SVGID_5_" },
        }),
      ]),
      _c(
        "g",
        {
          staticStyle: { "clip-path": "url(#SVGID_6_)" },
          attrs: { transform: "matrix(-1.6 0 0 1.59375 913 238)" },
        },
        [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_7_", d: "M-171.6-123.2h563.2v406.4h-563.2z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_8_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_7_" },
            }),
          ]),
          _c("g", { staticStyle: { "clip-path": "url(#SVGID_8_)" } }, [
            _c("path", {
              staticClass: "st5",
              attrs: { d: "M220 0h-67.8l-19.5 16.5H28.8V160H220z" },
            }),
            _c("path", { staticClass: "st6", attrs: { d: "M156.1 17h57.1z" } }),
            _c("path", {
              staticClass: "st2",
              attrs: { d: "M39.5 139.5h169.2z" },
            }),
            _c("path", {
              staticClass: "st5",
              attrs: { d: "M219.5 160H28.8L0 36.1h190.7z" },
            }),
          ]),
        ]
      ),
      _c("g", [
        _c(
          "g",
          { attrs: { transform: "matrix(-1.83032 0 0 1.82432 557 108)" } },
          [
            _c("path", {
              staticClass: "st5",
              attrs: {
                d: "M125.2 264.6c-.1 3.1.8 6.5.6 9.6 1.6 6.8 1.2 13.5.9 20.5-10.5 1.6-48.4.7-69.3 1.3-.1-6.8 18.7-14.8 29.8-19.3 1.9-.8 3.9-1.6 5.4-3.1 2.9-2.9 3-7.6 2.8-11.7 10.1-.6 20.1.4 29.8 2.7zM202.1 261.3c-.1 3.1 3.5 6.5 3.4 9.6 1.5 6.8 1.2 13.5.8 20.5-9.9 1.6-45.6.7-65.3 1.3-.1-6.8 17.6-14.8 28.1-19.3 1.8-.8 3.7-1.6 5.1-3.1 2.7-2.9 2.8-7.6 2.7-11.7 9.4-.6 16 .3 25.2 2.7z",
              },
            }),
            _c("path", {
              staticClass: "st7",
              attrs: {
                d: "M180.7 164.9c-2.4 8.5-10.9 22.2-10.8 31 .2 8.3 9.7 14.5 12.6 22.2 2 5.2 3.9 10.3 6 15.5 2.4 5.8 9.6 14.8 12 20.6 3 7.2 5.7 11.1 5.7 18.4-11.2.8-22.9.5-36-2.2-15.7-32.1-26.2-56.7-28.8-64.6-5.9-18.5 4.9-33 9.4-55.7 2-10.2 5.3-20.4 3.8-30.7 11.2 1 22.6.1 33.5-2.4-.5 16.2-3 32.3-7.4 47.9z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_9_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "132.781",
                  y1: "218.851",
                  x2: "165.153",
                  y2: "218.851",
                  gradientTransform:
                    "matrix(3.35 0 0 -3.3281 -378.508 755.433)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_9_)" },
              attrs: {
                d: "M97.5 39.2c3.4-7.4-1.9-10.2-1.7-18.4.1-3-.4-6.1-2-8.6-4-6-13.3-6-19.4-2.2-2.7 1.7-5 4-6.5 6.8-2.3 4.4-2.1 10 .6 14.2.8 1.3 2.4 10.2 3.5 11.3 2.5 2.6 7.4 1.5 10.2 3.6 2.2 1.6 7.3.7 9.7-.5 3.7-1.6 5.3-5.4 5.6-6.2z",
              },
            }),
            _c("path", {
              staticClass: "st6",
              attrs: {
                d: "M75.7 40.7c-1.5 0-3.2-.7-4.6-1.9-1.2-1-2.1-2.2-2.6-3.5s-.3-2.5.4-3.3c.6-.7 1.5-1.1 2.6-1.1 1.5 0 3.2.7 4.6 1.9 1.2 1 2.1 2.2 2.6 3.5s.3 2.5-.4 3.4c-.6.6-1.5 1-2.6 1zm-4.3-8.8c-.6 0-1.3.1-1.8.7s-.5 1.4-.2 2.4c.4 1.1 1.2 2.2 2.3 3 1.3 1 2.8 1.6 4 1.6.6 0 1.3-.1 1.8-.7s.5-1.4.2-2.4c-.4-1.1-1.2-2.2-2.3-3-1.3-1-2.7-1.6-4-1.6z",
              },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: {
                d: "M75.7 162.1c-.2-.7-.2-1.6.2-2.2.4-.6 1.2-1 2-.8l.6.3c2.3 1.4 4.7 2.4 7.2 3.4.5.2 1.1.5 1.4 1 .2.4.2.9.1 1.4-.1.9-.3 2-1.1 2.4-.5.3-1.2.3-1.9.1-.6-.2-1.2-.5-1.7-.8-1.3-.7-2.7-1.1-3.9-1.8-1.3-.6-2.5-1.6-2.9-3z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#f8afa9" },
              attrs: {
                d: "M99.1 38.7c.5.7 1.5 1 2.3 1.3 3.9 1.3 7.5 3.5 10.4 6.4 1.3-4.5 3.1-8.9 5.3-13-4.1-2.5-7.8-5.8-10.7-9.6-3 4.7-5.4 9.7-7.3 14.9z",
              },
            }),
            _c("path", {
              staticClass: "st11",
              attrs: {
                d: "M111.6 21.3c-2.6-5.6-5.9-11.1-10.5-15.1-4.7-4.1-10.9-6.7-17-6.1-11.7 1.3-16.5 10-18.3 15.9 10.3 1.7 23.8 30 22.4 41.1 8.2-5.8 15.5-12.9 21.5-20.9 1.8-2.4 3.5-5 3.7-8 .1-2.4-.8-4.7-1.8-6.9z",
              },
            }),
            _c("path", {
              staticClass: "st11",
              attrs: {
                d: "M85.7 58.4c-.3 0-.5-.2-.5-.5-.4-14.9-4.1-24.5-10.8-37.2-.1-.2 0-.5.2-.7.2-.1.5 0 .7.2C82 33 85.8 42.8 86.2 57.9c0 .3-.2.5-.5.5z",
              },
            }),
            _c("path", {
              staticClass: "st11",
              attrs: {
                d: "M62.5 15.6c1-1.8 3.3-2.5 5.3-2.7 5.4-.6 11 2.8 13 7.9-1.5 2.1-3.4 4.3-6.4 6.2-3.5 1.9-7.3 3.4-11.3 4.6-.8-2.3-3.6-10.4-.6-16z",
              },
            }),
            _c("path", {
              staticClass: "st12",
              attrs: {
                d: "M1 194c-6.6 2.8 20 4.5 37.5-4.2 4.8-2.4 11.8-6.4 15.1-9.7 8.8-8.9 13.2-13.1 10.9-17.7-2.4-4.8-7.3-4.7-20.9-1.9-6.2 1.3-10.9 3.1-16.6 6.1-17.4 9-4.7 18.4-26 27.4z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#fc6b65" },
              attrs: {
                d: "M30.6 187.5c-1.9-3-.3-7-.4-10.6-.1-3.7-2.3-7.3-5.5-9.1-14 8.4-3.4 17.6-23.6 26.2-6.2 2.6 16.6 4.3 34-2.6-1.6-1.3-3.5-2.2-4.5-3.9z",
              },
            }),
            _c("path", {
              staticClass: "st6",
              attrs: {
                d: "m272.9 65.8-61.4 36.9c-.3.2-.6.4-.9.5l-154 73.9-8.6-17.3 152.2-78.7c.6-.3 1.2-.6 1.9-.8l65-26.3c3.9-1.3 7.4-.9 9.2 2.7 1.8 3.7 0 6.8-3.4 9.1z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_10_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "134.49",
                  y1: "180.992",
                  x2: "168.875",
                  y2: "180.992",
                  gradientTransform:
                    "matrix(3.35 0 0 -3.3281 -378.508 755.433)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_10_)" },
              attrs: {
                d: "M95 138.2c-4.4 5.8-11.5 9.6-18.8 9.9-1.1 0-2.2 0-3.1.6-.9.5-1.4 1.9-.8 2.7.3.3.7.5 1.1.6 2.2.7 4.5 0 6.8-.1s5 1 5.2 3.3c.3 3.2-4 11.1-1.5 12.4 4.7 2.3 3-3 15.5-6.2 1.6-.4 1.9-2.6 2.3-4.2 1.5-6 3.4-11.3 4.7-18-4.2-1.1-5.6-.5-9.9-.5 1.9.8-3.5-1.4-1.5-.5z",
              },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: {
                d: "M113.8 138.5c.1-.2.3-.3.5-.3.9-.3 1.9.1 2.8.4 1.5.6 3 1.2 4.4 2 .3.2.9.3 1.2.4.6.3 1.1.4 1.8.6 1.5.5 3.2 2.5 2.2 3.8-.6.7-1.7.7-2.7.7-1.2 0-2.2-.6-3.3-1.2-1-.5-1.9-1.1-2.9-1.6-1.7-1-3.8-2-4.3-4 0-.1.1-.5.3-.8z",
              },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: {
                d: "M129.1 144.6c-1.1.4-2.5.5-3.5-.2s-1.5-1.7-2.5-2.3c-.5-.3-.8-.9-1.2-1.2-.2-.2-.4-.4-.5-.7-.3-.5-.6-1.1-.9-1.7-.3-.6-.5-1.3-.4-2s.5-1.3 1.2-1.5c.7-.1 1.3.3 1.9.6.6.4 1.1.8 1.7 1.2 1.1.9 2.1 2 2.8 3.2l1.2 1.2c.3.3.6.6.9 1 .3.7.4 2.1-.7 2.4z",
              },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: {
                d: "M132.3 143.5c-1 .2-2.1 0-2.9-.7-.8-.7-1.1-1.7-1.9-2.4-.4-.3-.8-.5-1.2-.9-.2-.2-.3-.4-.4-.7-.2-.5-.4-1-.6-1.6s-.2-1.2-.1-1.8.6-1.1 1.2-1.1 1.1.4 1.6.8.9.8 1.3 1.2c.9.9 1.6 2 2.1 3.2l.9 1.2c.2.3.5.6.6 1 .5.6.4 1.6-.6 1.8z",
              },
            }),
            _c("path", {
              staticClass: "st9",
              attrs: {
                d: "M134.9 142.8c-1.1.1-1.6.1-2.4-.6-.8-.7-3.6-5.3-3.8-5.9-.3-.7-.2-1.2-.1-1.8.2-.6.6-1.1 1.2-1.1s1.1.4 1.6.8.9.8 1.3 1.2c.9.9 1.6 2 2.1 3.2.3.4.9 2 1 2.4.2.6-.6 1.8-.9 1.8z",
              },
            }),
            _c("path", {
              staticClass: "st15",
              attrs: {
                d: "M180.6 87.1c8.5 15.3 14.5 33.4 8 49.6-4.8 11.9-11.1 15.6-17.4 20.7-6 4.8-12.1 17.4-16.3 23.8-4 6.1-14 14.7-16.4 21.6-2.8 7.8 1.7 10.9-.9 21-.9 3.5-3.8 10.9-5.4 14.2-1.5 3-.7 9.7-.9 13-.3 9.8-.6 11.5-3.3 20.9-.4 1.5-.9 3-2.2 3.9-1 .7-2.3.8-3.6.9-12.5.7-21.4.4-33.8-.9 5.6-26.4 13.7-83.8 15.9-89.5 2.1-5.2 5.3-9.8 8.5-14.4 12.4-17.7 19.1-28 31.5-45.7-2.9-7-.8-15.5-3.7-22.6 9.2-7 18.5-13.9 27.7-20.9 1.2-.9 2.4-1.8 3.9-2.1 3.8-.5 6.6 3.2 8.4 6.5z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_11_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "159.548",
                  y1: "195.068",
                  x2: "187.964",
                  y2: "265.17",
                  gradientTransform:
                    "matrix(3.35 0 0 -3.3281 -378.508 755.433)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_11_)" },
              attrs: {
                d: "M107.3 42.7c.6-2 5.6-12.4 5.6-12.4s7 2 8.7 2.6C152 44.6 157.7 55.7 178 81.1c.9 1.1 12.2 20.7 10.5 22.7-13.5 15.6-38.6 17.7-58.5 23.2-1.3-14-8.5-42.7-12.1-49.1-6-10.6-12.9-27.2-10.6-35.2z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_12_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "139.284",
                  y1: "198.952",
                  x2: "179.794",
                  y2: "198.952",
                  gradientTransform:
                    "matrix(3.35 0 0 -3.3281 -378.508 755.433)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_12_)" },
              attrs: {
                d: "M127.9 51.9c-2.3-4.7-6-16.3-11.3-16.5-3.6-.1-6.9 2.5-8.6 5.7s-4.6 10-5.1 13.6c-1.8 13.6-1.1 36.8-4.2 52.4-2.6 13.5-2.9 23.3-10.7 36.7 7.9 2.9 7.6 5.9 15.3 7.4 3.9-10 9.6-15.8 13.3-32.7 2.6-12.2 3.3-26 6.9-45.5.3-1.8 5.1-9.1 5-11 0-1.9.2-8.6-.6-10.1z",
              },
            }),
            _c("path", {
              staticStyle: {
                opacity: ".86",
                fill: "#fff",
                "enable-background": "new",
              },
              attrs: {
                id: "texture_1_-i2",
                d: "M151.4 130.4c-.1.1-.1.4.1.5.1.1.4.1.5-.1.1-.1.1-.4-.1-.5-.2-.1-.4-.1-.5.1zm-17.2 28.8c-.2 0-.3.2-.3.4s.2.3.4.4c.2 0 .3-.2.3-.4s-.2-.3-.4-.4zm8.6-.7c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4c-.1-.2-.3-.3-.4-.3zm-2.8-16.7c0 .2.1.4.2.4.2 0 .4-.1.4-.2 0-.2-.1-.4-.2-.4-.2-.1-.4 0-.4.2zm8.1 2.6c0 .2.1.4.2.4.2 0 .4-.1.4-.2 0-.2-.1-.4-.2-.4-.2-.1-.3 0-.4.2zm-5.3 30c-.2.1-.2.3-.1.5s.3.2.5.1.2-.3.2-.4c-.3-.3-.5-.3-.6-.2zm-.1-40.6c-.1.1 0 .3.1.4.1.1.3 0 .4-.1.1-.1 0-.3-.1-.4-.2-.1-.3-.1-.4.1zm7.1 3c-.1.1 0 .3.1.4.1.1.3 0 .4-.1.1-.1 0-.3-.1-.4-.2-.2-.4-.1-.4.1zm-7.2 29.1c-.2.1-.2.3-.2.4.1.2.2.3.4.2.2-.1.3-.2.2-.4 0-.1-.2-.2-.4-.2zm17.7-38.2c-.1.1-.1.3 0 .4.1.1.3.1.4 0 .1-.1.1-.3 0-.4-.1-.1-.3-.1-.4 0zm-16.8 21.4c-.2 0-.3.2-.3.3 0 .2.1.3.3.3s.3-.1.3-.3c0-.1-.2-.3-.3-.3zm7.6.1c-.2 0-.3.1-.3.3 0 .2.1.3.3.3s.3-.1.3-.3c.1-.2-.1-.3-.3-.3zm5.4-20.4c-.1.1 0 .2.1.3.1.1.2 0 .3-.1.1-.1 0-.2-.1-.3-.1-.1-.2 0-.3.1zm-.2 21.6c-.1 0-.1.1-.1.3 0 .1.2.2.3.1.1 0 .2-.2.1-.3-.1-.1-.2-.1-.3-.1zm8.7-28.9c-.1.1-.1.3 0 .3.1.1.3.1.3 0s.1-.3 0-.3c-.1-.1-.2 0-.3 0zm-30.4 13.4c-.2 0-.3.2-.4.4 0 .2.2.3.4.4.2 0 .3-.2.4-.4 0-.2-.2-.4-.4-.4zm8.9 0c-.2 0-.3.2-.4.4 0 .2.2.3.4.4.2 0 .3-.2.4-.4-.1-.3-.2-.4-.4-.4zm8.8 0c-.2 0-.3.2-.4.4 0 .2.2.3.4.4.2 0 .3-.2.4-.4 0-.2-.2-.4-.4-.4zm5.9-10.5c0 .2 0 .4.2.5.2 0 .4 0 .5-.2 0-.2 0-.4-.2-.5-.2 0-.5.1-.5.2zm-16.4 27c-.2.1-.3.3-.2.5s.3.3.5.2.3-.3.2-.5c-.1-.2-.3-.2-.5-.2zm8.2-3.4c-.2.1-.3.3-.2.5.1.2.3.2.5.2.2-.1.3-.3.2-.5s-.3-.2-.5-.2zm13.4-27.2c0 .2 0 .4.2.5.2 0 .4 0 .5-.2.1-.1.1-.4-.2-.5-.1-.1-.4-.1-.5.2zm-25.2 25.7c-.2.1-.3.3-.2.5s.3.3.5.2.3-.2.2-.5c-.2-.1-.4-.2-.5-.2zm8.3-3c-.2.1-.3.3-.2.5s.2.3.5.2c.2-.1.3-.3.2-.5-.2-.1-.4-.2-.5-.2zm8.2-3c-.2.1-.3.3-.2.5s.3.3.5.2.3-.3.2-.5c-.1-.2-.3-.3-.5-.2zm-5.8-12.5c-.2 0-.3.2-.4.4 0 .2.2.3.4.4.2 0 .3-.2.4-.4 0-.2-.2-.3-.4-.4zm8.9.4c-.2 0-.3.2-.4.4 0 .2.2.3.4.4.2 0 .3-.2.4-.4-.1-.3-.2-.4-.4-.4zm-4.6 16c-.2.1-.2.2-.1.4s.2.2.4.1.2-.2.1-.4-.2-.2-.4-.1zm-1.5-14.1c-.1 0-.2.2-.2.3s.2.2.3.2.2-.2.2-.3c-.1-.1-.2-.2-.3-.2zm6.5-1.1c-.1 0-.2.2-.3.3 0 .1.2.2.3.2.1 0 .2-.2.2-.3.1-.2 0-.3-.2-.2z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("g", [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_13_", d: "M-287.7 890.6h202.3v324.7h-202.3z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_14_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_13_" },
          }),
        ]),
        _c(
          "g",
          {
            staticStyle: { "clip-path": "url(#SVGID_14_)" },
            attrs: { transform: "matrix(-1.96364 0 0 1.95625 969 204)" },
          },
          [
            _c("defs", [
              _c("path", {
                attrs: {
                  id: "SVGID_15_",
                  d: "M-314.1-226.2h848.3v612.3h-848.3z",
                },
              }),
            ]),
            _c("clipPath", { attrs: { id: "SVGID_16_" } }, [
              _c("use", {
                staticStyle: { overflow: "visible" },
                attrs: { "xlink:href": "#SVGID_15_" },
              }),
            ]),
            _c(
              "g",
              { staticStyle: { "clip-path": "url(#SVGID_16_)" } },
              [
                _c("path", {
                  staticClass: "st5",
                  attrs: { d: "M220 0h-67.8l-19.5 16.5H28.8V160H220z" },
                }),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "SVGID_17_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "278.089",
                      y1: "165.273",
                      x2: "335.15",
                      y2: "165.273",
                      gradientTransform:
                        "matrix(3.8558 0 0 -3.8268 -916.154 649.468)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#e94a47" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#e5382a" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#SVGID_17_)" },
                  attrs: { d: "M156.1 17h57.1z" },
                }),
                _c("path", {
                  staticClass: "st2",
                  attrs: { d: "M39.6 139.5h169.2z" },
                }),
                _c("path", {
                  staticClass: "st5",
                  attrs: { d: "M219.5 160H28.8L0 36.1h190.7z" },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
      _c("g", [
        _c(
          "g",
          { attrs: { transform: "matrix(10.5062 0 0 10.27034 426 324)" } },
          [
            _c("defs", [
              _c("path", {
                attrs: {
                  id: "SVGID_18_",
                  d: "M-1259.8-1230.9h2542.5v2485.4h-2542.5z",
                },
              }),
            ]),
            _c("clipPath", { attrs: { id: "SVGID_19_" } }, [
              _c("use", {
                staticStyle: { overflow: "visible" },
                attrs: { "xlink:href": "#SVGID_18_" },
              }),
            ]),
            _c("g", { staticStyle: { "clip-path": "url(#SVGID_19_)" } }, [
              _c("path", {
                staticClass: "st6",
                attrs: {
                  id: "Decorative_Circle-i4",
                  d: "M20.9 18.8c-3.7 5.1-10.9 6.3-16.1 2.6-5.1-3.7-6.3-10.9-2.6-16.1C5.9.2 13.1-1 18.3 2.7s6.3 10.9 2.6 16.1zM4.7 7.1c-2.7 3.8-1.9 9 1.9 11.8 3.8 2.7 9 1.9 11.8-1.9 2.7-3.8 1.9-9-1.9-11.8-3.8-2.7-9-1.8-11.8 1.9z",
                },
              }),
            ]),
          ]
        ),
      ]),
      _c("g", [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_20_", d: "M774-38.3h413.9v806.6H774z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_21_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_20_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_21_)" } }, [
          _c("path", {
            staticClass: "st7",
            attrs: {
              d: "M901.6 601.4H938s14.6-12.4 28.6-31.7c15.6-21.9 6.9-55.7 36.3-79.7 15.7-12.9 21.4-43.2 26.5-50v-8c.6-37.8 4.5-82.2 7.4-109.1-1.1 2.8-2 6-3 9.4-7.7 24.6-31.3 31-31.3 31l-13-16c-4.7 8.4-12.9 24.3-17.3 38.3-6.5 20.3-70.6 215.8-70.6 215.8z",
              id: "L_trousers-i5",
            },
          }),
          _c("g", { attrs: { id: "shoe-i5" } }, [
            _c("path", {
              staticClass: "st12",
              attrs: {
                id: "R_shoe-i5",
                d: "m1069.7 601.4 17 47.6H966.8s6.1-11.9 26.6-20.7c20.4-8.8 39.7-26.8 39.7-26.8h36.6",
              },
            }),
            _c("path", {
              staticClass: "st12",
              attrs: {
                id: "R_shoe_1_-i5",
                d: "m938.1 601.4 17 47.6H835s6.1-11.9 26.6-20.7c20.4-8.8 39.7-26.8 39.7-26.8h36.8",
              },
            }),
          ]),
          _c("g", { attrs: { id: "trousers-i5" } }, [
            _c("path", {
              staticClass: "st15",
              attrs: {
                id: "R_trousers_1_-i5",
                d: "M1033 601.4h36.7c31.5-31 29.6-56.5 32-105.8 2.3-49.1 9.9-33.4 7.5-79.9-2.4-46.9-1.1-37.5 13.9-103.9 14.7-64.9-17.9-102.9-19.6-104.9-11.8 11.5-27.6 25.4-41 32.2 10.8 25.8-.9 45-8.5 52.5-7.8 7.8-11.9 14.3-17.7 31.5-2.8 26.8-6.8 71.3-7.4 109.1-.4 42.3 4.1 169.2 4.1 169.2z",
              },
            }),
          ]),
          _c("g", { attrs: { id: "_x36__17_-i5" } }, [
            _c("path", {
              staticStyle: { fill: "none" },
              attrs: {
                id: "_x31__98_-i5",
                d: "m1085.9 217.3-2.1 5.1-2.1-.9c1.4-1.5 2.8-2.8 4.2-4.2z",
              },
            }),
          ]),
          _c("path", {
            staticClass: "st2",
            attrs: {
              id: "texture_1_-i5",
              d: "M1067.9 246.1c-.1 0-.1 0-.3.1 0 .1 0 .1.1.3.1 0 .1 0 .3-.1 0-.1 0-.3-.1-.3zm4.5 2.2c0 .1-.1.1-.3.1s-.1-.1-.1-.3.1-.1.3-.1c.1.1.1.3.1.3zm-5.2-9.4c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1.1-.2.1 0 .1.1zm4.8 0c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1l.1-.1c.1 0 .1.1.1.1zm4.8.1c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1 0 .1.1zm-8.2 18.6c-.1.1-.1 0-.3 0v-.3h.3v.3zm-2.3-13c-.1.1-.3.1-.4.1-.1-.1-.1-.3-.1-.4.1-.1.3-.1.4-.1.1.1.1.2.1.4zm5.7 3.5c-.1.1-.3.1-.4.1-.1-.1-.1-.3-.1-.4.1-.1.3-.1.4-.1.2.1.2.3.1.4zm5.7 3.4c-.1.1-.3.1-.4.1-.1-.1-.1-.3-.1-.4.1-.1.3-.1.4-.1.2.3.2.4.1.4zm5.6 3.6c-.1.1-.3.1-.4.1-.1-.1-.1-.3-.1-.4.1-.1.3-.1.4-.1.3.1.3.4.1.4zm-8.6-22.3c0 .1 0 .3-.1.3s-.3 0-.3-.1 0-.3.1-.3c.2-.2.3 0 .3.1zm6.5-1.7c0 .1 0 .3-.1.3s-.3 0-.3-.1 0-.3.1-.3.3 0 .3.1zm6.5-1.6c0 .1 0 .3-.1.3s-.3 0-.3-.1 0-.3.1-.3c.2-.2.3 0 .3.1zm-16.1 10.7c0 .1-.1.3-.3.3s-.3-.1-.3-.3.1-.3.3-.3c0 0 .3.1.3.3zm6.5 1c0 .1-.1.3-.3.3s-.3-.1-.3-.3.1-.3.3-.3.3.1.3.3zm6.7 1.1c0 .1-.1.3-.3.3s-.3-.1-.3-.3.1-.3.3-.3.3.2.3.3zm6.5 1c0 .1-.1.3-.3.3s-.3-.1-.3-.3.1-.3.3-.3c.1 0 .3.2.3.3zm-22.7-5.4c0 .1-.1.1-.3.1s-.1-.1-.1-.3c0-.1.1-.1.3-.1.1.2.1.3.1.3zm5 1.1c0 .1-.1.1-.3.1-.1 0-.1-.1-.1-.3s.1-.1.3-.1c-.1.2.1.3.1.3zm4.9 1.3c0 .1-.1.1-.3.1-.1 0-.1-.1-.1-.3s.1-.1.3-.1c0 .2.1.3.1.3zm5 1.3c0 .1-.1.1-.3.1-.1 0-.1-.1-.1-.3s.1-.1.3-.1c-.1 0 .1 0 .1.3zm-16.9 7h-.3v-.3h.3v.3zm2.4 4.4h-.3v-.3h.3c.3.1.3.3 0 .3zm2.9 4.4h-.3v-.3h.3c.1.1 0 .3 0 .3zm4.5-24.7c0 .1 0 .1-.1.3-.1 0-.1 0-.3-.1 0-.1 0-.1.1-.3.2-.1.3.1.3.1zm5.2-.9c0 .1 0 .1-.1.3-.1 0-.1 0-.3-.1 0-.1 0-.1.1-.3.1 0 .3 0 .3.1zm5-.7c0 .1 0 .1-.1.3-.1 0-.1 0-.3-.1 0-.1 0-.1.1-.3 0 0 .3 0 .3.1zm-17.6 12.1c0 .1-.1.1-.3 0-.1 0-.1-.1 0-.3 0-.1.1-.1.3 0 .3 0 .3.1 0 .3zm4.3 2.9c0 .1-.1.1-.3 0-.1 0-.1-.1 0-.3 0-.1.1-.1.3 0v.3zm4.1 3.2c0 .1-.1.1-.3 0-.1 0-.1-.1 0-.3 0-.1.1-.1.3 0v.3zm4 2.8c0 .1-.1.1-.3 0-.1 0-.1-.1 0-.3 0-.1.1-.1.3 0s.2.3 0 .3zm-11.2-16.3s-.2.1 0 0c-.1 0-.3 0-.1-.1l.1.1c0-.2 0 0 0 0zm2.7.8c-.2.2-.2.2 0 0-.1 0-.3 0-.1-.1-.2.1-.1 0 .1.1zm2.5 1.2s0 .1 0 0c-.1 0-.3 0-.1-.1 0-.1 0-.1.1.1 0-.2 0 0 0 0zm-9.8 2.8h-.1v-.1h.1c.2 0 0 .1 0 .1zm1.2 2.6h-.1v-.2h.1v.2zm1.2 2.5h-.1v-.1h.1v.1zm7.1-13.5s-.1 0 0 0c-.1.1-.3 0-.3 0 0-.1 0-.1.3 0-.1-.1 0-.1 0 0zm2.7-.1s0 .1 0 0c-.1.1-.3 0-.3 0 .2 0 .2-.3.3 0 0-.3 0-.3 0 0zm-8.2 7.4h-.1v-.1h.1c.1.1.1.1 0 .1zm2.1 1.8h-.1v-.1h.1v.1zm2 2h-.1v-.1h.1v.1zm2.4-11.6c0 .1-.1.1-.3.1s-.1-.1-.1-.3.1-.1.3-.1c0 .1.1.1.1.3zm5.1 1c0 .1-.1.1-.3.1s-.1-.1-.1-.3.1-.1.3-.1c.1-.2.3.1.1.3zm5.4.7c0 .1-.1.1-.3.1s-.1-.1-.1-.3.1-.1.3-.1c.1.1.1.1.1.3zm5.2 1c0 .1-.1.1-.3.1s-.1-.1-.1-.3.1-.1.3-.1c0-.2.1 0 .1.3zm-20.1 4.2h-.3v-.3h.3c.2.2.2.3 0 .3zm3.1 4.4h-.3v-.3h.3c.2 0 0 .2 0 .3zm3 4.3h-.3v-.3h.3c.2.1.2.3 0 .3zm3.1 4.2h-.3v-.3h.3c.3.2.3.3 0 .3zm3-25.9c0 .1 0 .3-.1.3s-.3 0-.3-.1 0-.3.1-.3c0-.1.3-.1.3.1zm5.1-1.3c0 .1 0 .3-.1.3s-.3 0-.3-.1 0-.3.1-.3c.3-.2.3-.1.3.1zm5.3-1.3c0 .1 0 .3-.1.3s-.3 0-.3-.1 0-.3.1-.3c0 0 0 .1.3.1zm-21.6 11.1c0 .1-.1.1-.3 0-.1 0-.1-.1 0-.3 0-.1.1-.1.3 0v.3zm4.5 2.7c0 .1-.1.1-.3 0-.1 0-.1-.1 0-.3 0-.1.1-.1.3 0v.3zm4.6 3c0 .1-.1.1-.3 0-.1 0-.1-.1 0-.3 0-.1.1-.1.3 0v.3zm4.4 2.7c0 .1-.1.1-.3 0-.1 0-.1-.1 0-.3 0-.1.1-.1.3 0v.3zm4.4 2.7c0 .1-.1.1-.3 0-.1 0-.1-.1 0-.3 0-.1.1-.1.3 0 .1.1.1.3 0 .3zm-21.6-2.3c-.1 0-.3 0-.3-.1s0-.3.1-.3.3 0 .3.1-.1.3-.1.3zm1.2 5.1c-.1 0-.3 0-.3-.1s0-.3.1-.3.3 0 .3.1-.1.3-.1.3zm1.1 5.2c-.1 0-.3 0-.3-.1s0-.3.1-.3.3 0 .3.1c.2.2.2.2-.1.3zm1.3 5.2c-.1 0-.3 0-.3-.1s0-.3.1-.3.3 0 .3.1 0 .1-.1.3zm13-36.3s0 .1-.1.1c0 0-.1 0-.1-.1 0 0 0-.1.1-.1s.1 0 .1.1zm-7.4 10s-.1.1-.1 0-.1-.1 0-.1c0 0 .1-.1.1 0v.1zm3 1.5s-.1.1-.1 0c0 0-.1-.1 0-.1 0 0 .1-.1.1 0v.1zm3.1 1.8s-.1.1-.1 0c0 0-.1-.1 0-.1 0 0 .1-.1.1 0v.1zm-12.3 1.7s-.1 0-.1-.1 0-.1.1-.1c0 0 .1 0 .1.1 0-.2 0 .1-.1.1zm1 3.2s-.1 0-.1-.1c0 0 0-.1.1-.1 0 0 .1 0 .1.1-.1 0-.1.1-.1.1zm1 3.3s-.1 0-.1-.1c0 0 0-.1.1-.1 0 0 .1 0 .1.1-.1-.1-.1-.1-.1.1zm7.2-15.3c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1.1-.1.1.1.1.1zm3.6.4c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1s.1-.1.1.1zm3.2.3c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1.1-.1.1.1.1.1zm-13.2 4.8h-.1v-.1h.1v.1zm2.2 2.5h-.1v-.1h.1v.1zm1.9 2.7h-.1v-.1h.1c.3 0 .3.1 0 .1zm2.3 2.7h-.1v-.1h.1v.1zM1068 239c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1.1 0 .1.1.1.1.1.1-.1.1-.1.1zm-.3 3.6c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1.1 0 .1.1.1.1l-.1.1zm-.4 3.3c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1.1 0 .1.1.1.1.1.1.1.1-.1.1zm20.4-26.9c0 .1 0 .3-.1.3s-.3 0-.3-.1 0-.3.1-.3.3 0 .3.1zm5-1.8c0 .1 0 .3-.1.3s-.3 0-.3-.1 0-.3.1-.3.3-.1.3.1zm5-1.7c0 .1 0 .3-.1.3s-.3 0-.3-.1 0-.3.1-.3c.1-.4.3-.2.3.1zm-15.4 13.6c0 .1-.1.1-.3.1s-.1-.1-.1-.3.1-.1.3-.1c.1 0 .3.2.1.3zm4.9 2.1c0 .1-.1.1-.3.1-.1 0-.1-.1-.1-.3 0-.1.1-.1.3-.1.1.2.2.3.1.3zm4.8 2.3c0 .1-.1.1-.3.1s-.1-.1-.1-.3.1-.1.3-.1c.1 0 .1.2.1.3zm4.8 2.1c0 .1-.1.1-.3.1s-.1-.1-.1-.3.1-.1.3-.1c.1.2.1.3.1.3zm-20.5-1.1c-.1 0-.3 0-.3-.1s0-.3.1-.3.3 0 .3.1-.1.3-.1.3zm1.8 5c-.1 0-.3 0-.3-.1s0-.3.1-.3.3 0 .3.1c0 .3 0 .3-.1.3zm1.8 5.1c-.1 0-.3 0-.3-.1s0-.3.1-.3.3 0 .3.1c.1.1.1.1-.1.3zm1.9 4.8c-.1 0-.3 0-.3-.1s0-.3.1-.3.3 0 .3.1 0 .3-.1.3zm4.4-24.7c0 .1-.1.1-.3.1s-.1-.1-.1-.3.1-.1.1-.1c.3 0 .3.2.3.3zm5.4.3c0 .1-.1.1-.3.1-.1 0-.1-.1-.1-.3s.1-.1.1-.1c0-.1.3 0 .3.3zm5.1 0c0 .1-.1.1-.3.1-.1 0-.1-.1-.1-.3s.1-.1.3-.1c.1.3.2.3.1.3zm5.2.3c0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.3-.1v.1zm-23.7 4.9c-.1.1-.3.1-.3 0-.1-.1-.1-.3 0-.3.1-.1.3-.1.3 0 .2.1.2.2 0 .3zm3.7 3.9c-.1.1-.3.1-.3 0-.1-.1-.1-.1 0-.3s.1-.1.3 0c.2 0 .2.1 0 .3zm3.6 3.8c-.1.1-.3.1-.3 0-.1-.1-.1-.1 0-.3.1-.1.3-.1.3 0 .1.2.1.3 0 .3zm3.5 3.8c-.1.1-.3.1-.3 0-.1-.1-.1-.3 0-.3.1-.1.3-.1.3 0 .3.2.3.2 0 .3zm3.7 3.9c-.1.1-.3.1-.3 0-.1-.1-.1-.1 0-.3s.3-.1.3 0v.3zm-20.3-8c-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.1.1 0 .1.1.1.3h-.1v-.1zm-.3 5.3c-.1 0-.1-.1-.1-.3s.1-.1.1-.1c.1 0 .1.1.1.1.2.3.1.3-.1.3zm-.1 5.2c-.1 0-.1-.1-.1-.3s.1-.1.3-.1.1.1.1.3c-.2.1-.2.1-.3.1zm-.1 5.3c-.1 0-.1-.1-.1-.1 0-.1.1-.1.3-.1s.1.1.1.3c-.2-.1-.2-.1-.3-.1zm13.6-31.8s0 .1 0 0c-.1.1-.3 0-.3 0 0-.2.1-.2.3 0 0-.2 0-.2 0 0zm3.1 0c0 .1 0 .1 0 0-.1.1-.3 0-.3 0 .1 0 .1-.2.3 0 0-.2 0 0 0 0zm3.2.1s0 .2 0 0c-.1.1-.3 0-.3 0 .2-.1.2-.1.3 0 0-.1 0-.1 0 0zm-9.5 6.6h-.1v-.1h.1c.2-.1.2.1 0 .1zm2.3 2.4h-.1v-.1h.1v.1zm2.1 2.2h-.1v-.1h.1c.2 0 .2.1 0 .1zm-11.3-2.1s-.1 0 0 0c-.1-.1 0-.3 0-.3.1.2.1.2 0 .3.1 0 .1 0 0 0zm0 3.3c-.1 0-.1-.2 0 0-.1-.1 0-.3 0-.3v.3c0-.2 0 0 0 0zm-.1 3.1c-.2 0-.2 0 0 0-.1-.1 0-.3 0-.3s.1.2 0 .3c.1 0 0 0 0 0zm17.1-22.6s0 .1-.1.1c0 0-.1 0-.1-.1 0 0 0-.1.1-.1 0 .1.1.1.1.1zm-9.1 9.7s-.1.1-.1 0c0 0-.1-.1 0-.1 0 0 .1-.1.1 0-.1-.1 0 .1 0 .1zm2.9 1.4s-.1.1-.1 0c0 0-.1-.1 0-.1 0 0 .1-.1.1 0v.1zm2.8 1.3s-.1.1-.1 0c0 0-.1-.1 0-.1 0 0 .1-.1.1 0v.1zm3.1 1.3s-.1.1-.1 0c0 0-.1-.1 0-.1 0 0 .1-.1.1 0v.1zm-13.2.4s-.1 0-.1-.1c0 0 0-.1.1-.1 0 0 .1 0 .1.1-.1-.1-.1-.1-.1.1zm1 2.8s-.1 0-.1-.1c0 0 0-.1.1-.1 0 0 .1 0 .1.1s.1.1-.1.1zm1.3 3s-.1 0-.1-.1c0 0 0-.1.1-.1 0 0 .1 0 .1.1l-.1.1zm1 3.1s-.1 0-.1-.1c0 0 0-.1.1-.1 0 0 .1 0 .1.1 0 0 0 .1-.1.1zm3.7-14c-.1 0-.1-.1-.1-.1s.1-.1.1.1c0-.2.3 0 0 0zm2.1 1.7c-.1 0-.1 0 0 0-.1 0-.1-.1-.1-.1 0-.2 0-.2.1.1 0-.3 0-.3 0 0zm-9.1 2c-.1-.1-.1-.1 0-.1v.1zm.5 2.7c-.2 0-.2 0 0 0-.1-.1-.1-.1 0-.1v.1zm9.9-9.8c0 .2-.3.2 0 0h-.1c-.2-.2-.2-.2.1 0 0-.2 0 0 0 0zm2.4.8h-.1c0-.1.1-.1.1 0 0-.1.1 0 0 0zm-9.2 4c-.2 0-.2 0 0 0l-.1-.1c-.1-.2.1.1.1.1zm1.1 2.3c-.1 0-.1 0 0 0l-.1-.1c0-.2.1-.2.1.1zm1.3 2.2s-.1 0 0 0l-.1-.1c.1-.2.1-.2.1.1.1-.1 0 0 0 0zm2.6-9.3h-.1v-.2h.1c.1.2.1.2 0 .2zm1.4 2.9h-.1v-.1h.1c.1 0 .1.1 0 .1zm-5.8 3.2c-.1-.1-.1-.3 0-.3.1.1.1.1 0 .3.1 0 .1 0 0 0z",
            },
          }),
          _c(
            "g",
            { attrs: { id: "sweater_2_-i5" } },
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "sweater_3_-i5_1_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "2143.478",
                    y1: "-2465.713",
                    x2: "2169.253",
                    y2: "-3091.674",
                    gradientTransform:
                      "matrix(.1488 0 0 -.1494 709.44 -195.588)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#23286b" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#161c54" },
                    attrs: { offset: ".999" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#sweater_3_-i5_1_)" },
                attrs: {
                  id: "sweater_3_-i5",
                  d: "M948 149.6s25.9-10.4 60.2-7.8c34.4 2.6 40.3 12.8 60.1 15.1 19.8 2.3 45.2 3.7 52.9 32.1 0 0-35.2 39.3-60.1 51.1l-124.7-68.6c-.1 0 11.7-5.9 11.6-21.9z",
                },
              }),
            ],
            1
          ),
          _c("path", {
            staticClass: "st26",
            attrs: {
              id: "R_hand-i5",
              d: "M947.5 296.8s-14.7 15.2-27.8 22.6c-13 7.4-14.3 6.5-21 1.8-6.7-4.7-14.3-12.6-16.6-15.2-2.1-2.6-6.9-1.8-4.4 5.7 2.6 7.4 13.9 9.7 10.3 14.3-3.4 4.8-18.3 8.8-29.5 10.4-11.2 1.8-17.3 3-4.8 14.8 12.6 11.8 26.1 17.3 54.7-2.1 28.8-19.6 51.3-22 62.5-23.3l-23.4-29z",
            },
          }),
          _c("path", {
            staticClass: "st12",
            attrs: {
              id: "R_sleeve_1_-i5",
              d: "M936.3 171.5s28.2 31.4 39.1 56.4 8.1 31.4-8.5 47.7c-16.7 16.3-21.1 18.7-21.1 18.7l56.4 69s23.7-6.4 31.3-31c7.7-24.6 11.8-31.8 21-40.9 9.1-9.1 24.1-34.5-.4-68.2s-51.6-54.8-106-73.8",
            },
          }),
          _c("path", {
            staticClass: "st26",
            attrs: {
              id: "neck_1_-i5",
              d: "M920.3 158.1s7.7 4.4 16 13.3c0 0 11.8-2 11.6-21.9l-23.7-11.1-3.9 19.7",
            },
          }),
          _c("path", {
            staticClass: "st26",
            attrs: {
              id: "face_2_-i5",
              d: "M870 140.6c0 .1.1.3.1.3.3.6.6 1.4 1.1 2 4 7.2 2.7 16 4.1 17.8 1.3 1.8 5.7.4 7.7-.4 1.8-1.1 9.9 6.1 20.4 6.1 9.8 0 19.3-7.5 23.2-15.9-7.5-16.2-14.6-21.4-32.9-17.9-20 3.7-26.4-6.8-26.4-6.8-.5 6.9 2 13.3 2.7 14.8z",
            },
          }),
          _c("g", { attrs: { id: "hair-i5" } }, [
            _c("path", {
              staticClass: "st6",
              attrs: {
                id: "hair_6_-i5",
                d: "M867.3 125.9s6.1 10.5 26.4 6.8c20-3.7 26.6 2.8 35 22.6 0 0 28.9-12.5 40.7-42.9 0 0-5.7-6.5-16.7-8-11.1-1.4-24.1-14.5-28.2-18.2-4.1-3.7-23.2-10.7-39.5 1.4-16.4 12.2-32.9 32.7-14.6 53.2-.2.4-3.6-7-3.1-14.9z",
              },
            }),
            _c("path", {
              staticClass: "st27",
              attrs: {
                id: "hair_5_-i5",
                d: "M878.2 127.9c20.7.1 47.5 5.1 46.5 31.5 0 .9-1.6.9-1.6 0 .9-25.7-25.1-29.8-44.9-30-1 0-1-1.5 0-1.5z",
              },
            }),
            _c("path", {
              staticClass: "st27",
              attrs: {
                id: "hair_4_-i5",
                d: "M970.5 111.1c-9.9-16-34.3-.9-44.5-17-.4-.7.7-1.6 1.4-.7 10.1 15.6 34.4.6 44.5 17 .3.8-1 1.7-1.4.7z",
              },
            }),
          ]),
          _c("path", {
            staticStyle: { fill: "#1c2868" },
            attrs: {
              id: "eye-i5",
              d: "M882.9 143.6c-.4 5-5.8 7.8-10.1 4.7-.7-.6 0-1.8.7-1.4 3.1 2.3 7.5.6 7.8-3.4.2-.9 1.6-.9 1.6.1z",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }